const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';
const IMAGES_BASE_URL = `${API_BASE_URL}/retrieve/images`;

export const imageIdToUrl = (imageId: string | null): string | null => {
  if (!imageId) return null;
  return `${IMAGES_BASE_URL}/${imageId}`;
};
